export default "__VITE_ASSET__CSLa$YKS__"